import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const InsuranceAgency = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my insurance agency business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps insurance agency businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for insurance agency businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most insurance agency businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my insurance agency business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like insurance agency. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Insurance Agency - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Insurance Agency CRM", url: "/industries/insurance-agency" }
  ];

  const industryData = {
    name: 'Insurance Agency',
    title: 'Stop Losing Leads & Automate Your Policy Renewal Reminders',
    subtitle: 'Capture every quote request, nurture leads until they buy, and never miss a renewal',
    icon: '🛡️',
    challenges: [
      'Leads go cold while waiting for quotes',
      'Hard to follow up on all quote requests',
      'Clients forget about renewal dates',
      'Difficult to cross-sell additional policies',
      'Too much time spent on admin work'
    ],
    solutions: [
      'Instant quote request capture and response',
      'Automated lead nurture sequences',
      'Renewal reminder automation',
      'Cross-sell campaigns for existing clients',
      'Policy management automation'
    ],
    features: [
      'Lead CRM with policy tracking',
      'Automated quote follow-ups',
      'Policy renewal reminders',
      'Cross-sell automation',
      'Referral program management',
      'Online quote forms',
      'Document management',
      'Multi-line tracking'
    ],
    results: [
      '60% more quotes convert to policies',
      '95% renewal rate',
      '40% increase in cross-sells',
      '£8.7K average monthly commission increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Insurance Agency UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for insurance agency businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for insurance agency UK, insurance agency business software, insurance agency customer management, insurance agency lead generation UK"
        url="/industries/insurance-agency"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default InsuranceAgency;